// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useFormik } from "formik";
// COMPONENTS
import Select from 'react-select';
import { Divider } from '@material-ui/core'
import { Link, useParams } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import MaskedInput from 'react-maskedinput';
// CUSTOM COMPONENTS
import * as alert from '../../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as plmDataSheetService from '../../../../../services/form/plmDataSheetService';
import acmLogFormLineItemValidator from '../../../../../helpers/validators/ACMLogLineItemValidator';
import * as jobFormService from '../../../../../services/service/jobFormService';
import * as helper from "../../../../../helpers/helper";
import { saveLineItemDescription } from '../../../../../services/form/plmChainOfCustodyService';
import { TextsmsOutlined } from '@material-ui/icons';
//STYLES AND ASSETS

const initialState = {
    id: 0,
    inspectorId: 0,
    projectLocationId: null,
    surveyDate: new Date(),
    client: '',
    projectNumber: '',
    inspector: '',
    plmDataSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    sampleNumber: '',
    haNumber: '',
    description: '',
    location: '',
    quantity: '',
    findingComparison: '',
    findingPercentage: '',
    findingType: '',
    neshapClassification: ''
}

const findingComparisonOptions = [{ label: 'None', value: 'None' }, { label: '<', value: '<' }]

const findingTypeOptions = [{ label: 'None Detected', value: 'None Detected' }, { label: 'Chrysotile', value: 'Chrysotile' }, { label: 'Amosite', value: 'Amosite' }
    , { label: 'Crocidolite', value: 'Crocidolite' }, { label: 'Tremolite', value: 'Tremolite' }, { label: 'Other-Type', value: 'Other-Type' }]

const ACMLogForm = (props) => {
    const iframeRef = useRef();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history } = props;
    const { jobFormId, edit } = useParams();
    const [loading, setLoading] = useState(false);
    const [acmLog, setACMLog] = useState(initialState);
    const [acmLogToEdit, setACMLogToEdit] = useState({});
    const [switchMode, setSwitchMode] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refreshPage, setRefreshPage] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        projectName: '',
        client: "",
        plmChainOfCustodyId: 0,
        plmChainOfCustodyJobFormId: 0,
        name: "PLM Data Sheet",
        actualAssignedDate: new Date(),
        submittedById: 0,
        inspector: null,
        jobId: 0,
    });

    useEffect(() => {

        if (jobFormId) {
            if (edit == 'false') {
                setSwitchMode(true)
                getReport(jobFormId)
            }
            else {
                fetchJobLocations().then(res => {
                    fetchHAPLMDataSheet(res);
                });
            }
        }
    }, [refreshPage])

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const fetchHAPLMDataSheet = (projectLocations) => {
        setLoading(true);
        plmDataSheetService.getPLMDataSheetById(jobFormId).then(res => {
            if (res.plmDataSheet && res.plmDataSheet.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.plmDataSheet.projectLocationId).label);
            }
            setIsReadOnly(res.submittedById !== 0);
            res.plmDataSheet.plmDataSheetLineItems = res.plmDataSheet.plmDataSheetLineItems.filter(x => !(x.findingComparison == '<') && !(x.findingComparison && x.findingComparison.match(/\None+/g)));
            setJobForm(res);
            res.plmDataSheet && setACMLog(res.plmDataSheet);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const getReport = (id) => {
        if (id) {
            plmDataSheetService.getACMLogForm(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {!isReadOnly &&
                                <>
                                    <button
                                        type="button"
                                        href="#"
                                        className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => editLineItem(acmLog.plmDataSheetLineItems[dataIndex].id)}
                                    >
                                        Edit
                                    </button>
                                </>
                            }
                        </>
                    );
                }
            },
        },
        {
            name: "haNumber",
            label: "HA No.",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "description",
            label: "Material Description",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findingComparison",
            label: "Finding Comparison",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findingPercentage",
            label: "Finding Percentage",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findingType",
            label: "Finding Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "neshapClassification",
            label: "NESHAP Classification",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {acmLog.plmDataSheetLineItems[dataIndex].neshapClassification ?? '-'}
                        </>
                    );
                }
            }
        },
        {
            name: "quantity",
            label: "Approximate Quantity",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ];

    const removeLineItem = (id) => {
        setProcessing();
        plmDataSheetService.deleteLineItem(id).then(res => {
            let temp = [...acmLog.acmLogLineItems];
            temp.splice(temp.findIndex(x => x.id === id), 1);
            setACMLog({ ...acmLog, acmLogLineItems: temp });
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const editLineItem = (id) => {
        setProcessing();
        setIsModalOpen(true);
        let temp = [...acmLog.plmDataSheetLineItems];
        setACMLogToEdit({ ...temp.find(x => x.id == id) })
    }

    const handleModalClose = () => {
        setIsModalOpen(false);
        setACMLogToEdit({})
        formik_lineItem.resetForm();
    }

    const saveLineItems = (values, setSubmitting) => {
        plmDataSheetService.saveLineItem({ ...values, plmDataSheetId: acmLog.id }).then(res => {
            let temp = [...acmLog.plmDataSheetLineItems];
            temp[temp.findIndex(x => x.id == values.id)] = { ...values, id: res.id };
            setACMLog({ ...acmLog, plmDataSheetLineItems: temp });
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            setLoading(false);
            setSubmitting(false);
            handleModalClose();
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: acmLog,
        // validationSchema: acmLogFormValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            // saveForm(values).finally(() => {
            //     setLoading(false);
            //     setSubmitting(false);
            // });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: acmLogToEdit,
        validationSchema: acmLogFormLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveLineItems(values, setSubmitting)
        }
    });

    const saveForm = (values) => {
        return plmDataSheetService.save(values).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        formik.validateForm().then(res => {
            if (Object.keys(res).length > 0) {
                let err = "";
                for (const property in res) {
                    err += res[property] + ". ";
                }

                showAlert({ message: err + " Please save before submitting the form", variant: 'error' });
                return;
            }

            saveForm(formik.values).then(res => {
                jobFormService.submitForm(jobForm.id).then(res => {
                    showAlert({ message: res.message, variant: 'success' });
                    history.push("/services/manage-job/forms/" + jobForm.jobId);
                }).catch(ex => {
                    showAlert({ message: ex.message, variant: 'error' })
                })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    <div className="card card-custom card-stretch">
                        <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                            <form className="card card-custom" onSubmit={formik_lineItem.handleSubmit}>
                                <Modal.Header closeButton>
                                    <Modal.Title>ACM Log Entry</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="form">
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                HA #
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    readOnly
                                                    type="text"
                                                    placeholder="Enter HA Number"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="haNumber"
                                                    {...formik_lineItem.getFieldProps("haNumber")}
                                                />
                                                {formik_lineItem.touched.haNumber && formik_lineItem.errors.haNumber ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.haNumber}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Material Description
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Form.Control as="textarea" rows="5"
                                                    readOnly
                                                    placeholder="Enter Description"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="description"
                                                    {...formik_lineItem.getFieldProps("description")}
                                                />
                                                {formik_lineItem.touched.description && formik_lineItem.errors.description ? (
                                                    <div className="invalid-feedback">
                                                        {formik_lineItem.errors.description}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Location
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    readOnly
                                                    type="text"
                                                    placeholder="Enter Location"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="location"
                                                    {...formik_lineItem.getFieldProps("location")}
                                                />
                                                {formik_lineItem.touched.location && formik_lineItem.errors.location ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.location}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Comparison
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    readOnly
                                                    type="text"
                                                    placeholder="Enter Finding Comparison"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="findingComparison"
                                                    {...formik_lineItem.getFieldProps("findingType")}
                                                />
                                                {formik_lineItem.touched.findingComparison && formik_lineItem.errors.findingComparison ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingComparison}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Percentage
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                {/* <input
                                        type="text"
                                        placeholder="Enter Findings Percentage"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="findingPercentage"
                                        {...formik_lineItem.getFieldProps("findingPercentage")}
                                    /> */}
                                                <MaskedInput
                                                    readOnly
                                                    className="form-control form-control-lg form-control-solid"
                                                    mask="11.11%"
                                                    placeholder="Enter Findings Percentage"
                                                    {...formik_lineItem.getFieldProps("findingPercentage")}
                                                />
                                                {formik_lineItem.touched.findingPercentage && formik_lineItem.errors.findingPercentage ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingPercentage}
                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Type
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    readOnly
                                                    type="text"
                                                    placeholder="Enter Finding Type"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="findingType"
                                                    {...formik_lineItem.getFieldProps("findingType")}
                                                />
                                                {formik_lineItem.touched.findingType && formik_lineItem.errors.findingType ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingType}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                NESHAP Classification
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    type='text'
                                                    placeholder="NESHAP Classification"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="neshapClassification"
                                                    {...formik_lineItem.getFieldProps("neshapClassification")}
                                                />
                                                {formik_lineItem.touched.neshapClassification && formik_lineItem.errors.neshapClassification ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.neshapClassification}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Approx. Quantity
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    readOnly
                                                    type='text'
                                                    placeholder="Enter Quantity"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="quantity"
                                                    {...formik_lineItem.getFieldProps("quantity")}
                                                />
                                                {formik_lineItem.touched.quantity && formik_lineItem.errors.quantity ? (
                                                    <div className="invalid-feedback">
                                                        {formik_lineItem.errors.quantity}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleModalClose}>
                                        Close
                                    </Button>
                                    <button
                                        type="submit"
                                        className="btn btn-success mr-2"
                                        disabled={
                                            formik_lineItem.isSubmitting || (formik_lineItem.touched && !formik_lineItem.isValid)
                                        }
                                    >
                                        Save
                                        {formik_lineItem.isSubmitting}
                                    </button>
                                </Modal.Footer>
                            </form>
                        </Modal>
                        {loading && <ModalProgressBar />}
                        <div className="card-header py-3">
                            <div className="card-title align-items-start flex-column">
                                <h3 className="card-label font-weight-bolder text-dark">
                                    ACM Log Form - ({moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")})
                                </h3>
                                {/* <h4 className="card-label font-weight-bolder text-dark">
                       {JSON.stringify(setLocationOptions[0])}
                    </h4> */}
                                {jobForm.client + ' - ' + jobForm.projectName}
                            </div>
                            <div className="card-toolbar">
                                {
                                    <>
                                        <button
                                            className={`btn btn-info mr-2`}
                                            onClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        >
                                            Print Form
                                        </button>

                                    </>
                                }
                            </div>
                        </div>
                        <div className="form">
                            <form className="card card-custom" onSubmit={formik.handleSubmit}>
                                <fieldset disabled={isReadOnly}>
                                    <div className="card-body">
                                        <Row>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        AES Project#
                                                    </label>
                                                    <div className="col-xl-9">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="21-0003-01"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="name"
                                                            value={jobForm.projectNumber}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Client
                                                    </label>
                                                    <div className="col-xl-9">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="Primtek LLC"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="client"
                                                            value={jobForm.client}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Date
                                                    </label>
                                                    <div className="col-xl-9">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="08/09/2021"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="date"
                                                            value={moment(acmLog.date).format("MM/DD/YYYY")}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Project Location
                                                    </label>
                                                    <div className="col-xl-9">
                                                        <input
                                                            readOnly
                                                            value={selectedLocation}
                                                            type='text'
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="projectTypeId"
                                                        // {...formik.getFieldProps('projectLocationId')}
                                                        />
                                                        {formik.touched.projectLocationId && formik.errors.projectLocationId ? (
                                                            <div className="invalid-feedback">
                                                                {formik.errors.projectLocationId}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="d-flex">
                                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">ACM Log Items</h5>
                                        </div>
                                        <Divider />
                                        <MUIDataTable
                                            data={acmLog.plmDataSheetLineItems}
                                            columns={columns}
                                            options={{
                                                selectableRows: 'none',
                                            }}
                                        />
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
            }
        </>


    )
}


export default connect(null, {
    ...alert.actions,
    ...confirmModal.actions
})(ACMLogForm);